import { app } from '../../../../app';

app.service('ChooseSharedFolder', modal);

/** @ngInject */
function modal($uibModal) {
    return (sharedFolders) => {
        return $uibModal.open({
            component: 'companySharingCenterSharedFoldersChoose',
            resolve: {
                sharedFolders: () => sharedFolders,
            },
        }).result;
    };
}


// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/choose-folder/choose-shared-folder.modal.js